import React, { Component } from 'react';
import { View, Platform } from 'react-native'

import { VFButton, PasswordInput } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import Navigation from '@vfgroup-oneplatform/foundation/Utils/Navigation';
import { isFunction as _isFunction, find as _find } from 'lodash';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';

import LoginTestKeys from '../../Utils/LoginTestKeys';
import AuthContainer from '../AuthContainer/AuthContainer';

import styles from './ConfirmNewPassword.Styles';

class ConfirmNewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        password: '',
        confirmationPassword: '',
      },
      errors: {},
      isSubmitting: false,
      showErrorBox: false,
      errorMessage: '',
      subErrorMessage: '',
      showPasswordIcon: false,
    };
    this.timeOut = {};
    this.validations = {
      confirmationPassword: this.handleConfirmationPasswordValidation,
      password: this.handlePasswordValidation,
    };
  }

  onNewPasswordConfirm = async () => {
    const { values } = this.state;
    const { password } = values;
    const onNewPasswordConfirm = Navigation.instance.getParam(
      this,
      'onNewPasswordConfirm',
      () => null,
    );
    const onNewPasswordConfirmSuccess = Navigation.instance.getParam(
      this,
      'onNewPasswordConfirmSuccess',
      () => null,
    );

    this.setState({
      isSubmitting: true,
      showErrorBox: false,
    });
    try {
      const result = await onNewPasswordConfirm(password);
      onNewPasswordConfirmSuccess(result?.response, result);
      this.setState({
        isSubmitting: false,
      });
    } catch (error) {
      this.setState({
        showErrorBox: true,
        errorMessage: error.errorMessage,
        subErrorMessage: error.subErrorMessage,
        isSubmitting: false,
      });
    }
  };
  getErrorFieldProps = isError => {
    return {
      ...this.props.theme.colors.textInput[isError ? 'error' : 'default'],
      showHelperText: isError,
    };
  };
  getErrorFieldPropsMemoized = memoize(this.getErrorFieldProps);
  getErrorProps = (showErrorBox, errorMessage, subErrorMessage) => {
    return {
      showErrorBox,
      errorMessage,
      subErrorMessage,
      accessible: false,
    };
  };
  getErrorPropsMemoized = memoize(this.getErrorProps);
  getIsFormErrorState = () => {
    const { errors, values } = this.state;
    const errExist = _find(errors, d => (d.error && d.validated) || !d.validated);
    const AllInputsValidated = Object.keys(errors).length == Object.keys(values).length;
    return errExist || !AllInputsValidated;
  };
  handleUpdateErrState = (key, isFieldValid) => {
    this.setState(state => {
      return {
        errors: {
          ...state.errors,
          [key]: { error: !isFieldValid, validated: true },
        },
      };
    });
  };
  handlePasswordValidation = value => {
    const { values } = this.state;
    const { confirmationPassword } = values;
    const validatePassword = Navigation.instance.getParam(this, 'validatePassword', () => true);
    const isPasswordValid = _isFunction(validatePassword) && validatePassword(value);
    this.handleUpdateErrState('password', isPasswordValid);
    if (confirmationPassword) {
      this.handleConfirmationPasswordValidation();
    }
  };
  handleResetFieldValidationState = key => {
    this.setState(state => ({
      errors: {
        ...state.errors,
        [key]: { ...state.errors[key], validated: false },
      },
    }));
  };
  handleConfirmationPasswordValidation = () => {
    const { values } = this.state;
    const { password, confirmationPassword } = values;
    const isValid = confirmationPassword == password;
    this.handleUpdateErrState('confirmationPassword', isValid);
  };
  handleValidation = (key, value, validate) => {
    this.handleResetFieldValidationState(key);
    if (!value) {
      return;
    }
    if (this.timeOut[key]) {
      clearTimeout(this.timeOut[key]);
    }
    this.timeOut[key] = setTimeout(() => validate(value), 800);
  };
  handleInputChange = (fieldName, value) => {
    const { values } = this.state;
    this.setState(
      { values: { ...values, [fieldName]: value }, showErrorBox: false },
      this.handleValidation(fieldName, value, this.validations[fieldName]),
    );
  };

  shouldShowErrorText = key => {
    const { errors, values } = this.state;
    return errors[key]?.error && errors[key]?.validated && values[key];
  };

  render() {
    const { theme, navigation } = this.props;
    const renderTitle = Navigation.instance.getParam(this, 'renderTitle', null);

    const {
      password,
      isSubmitting,
      confirmationPassword,
      showErrorBox,
      errorMessage,
      subErrorMessage,
    } = this.state;
    return (
      <AuthContainer
        tobiSize={114}
        renderTobiLessIconView={Navigation.instance.getParam(this, 'renderLoginIconView', null)}
        errorProps={this.getErrorPropsMemoized(showErrorBox, errorMessage, subErrorMessage)}
        renderTitle={renderTitle}
        tobiTestId={LoginTestKeys.loginAuthContainerTobiIcon}
        {...Platform.select({
          web: {
            backBtn: true,
            backBtnPress: () => navigation?.pop(1)
          },
          default: {

          }
        })
        }
      >
        <View style={styles.containerStyle}>
          <PasswordInput
            label="confirm_new_password_password_hint"
            value={password}
            {...this.getErrorFieldPropsMemoized(this.shouldShowErrorText('password'))}
            helperText={'confirm_new_password_error_enter_valid_password'}
            onChangeText={value => {
              this.handleInputChange('password', value);
            }}
            labelTextStyle={styles.labelTextStyle}
            containerStyle={styles.passwordInputStyle}
            inputAccessibilityLabel={LoginTestKeys.loginPassTxtInput}
            rightIconAccessibilityLabel={LoginTestKeys.textInputEndIcon}
            selectionColor={theme.colors.textInput.default.selectionColor}
            textColor={theme.colors.textColor}
            helperTextColor={theme.colors.textInput.error.tintColor}
          />
          <PasswordInput
            label="confirm_new_password_confirm_password_hint"
            value={confirmationPassword}
            onChangeText={value => this.handleInputChange('confirmationPassword', value)}
            {...this.getErrorFieldPropsMemoized(this.shouldShowErrorText('confirmationPassword'))}
            helperText={'confirm_new_password_error_enter_valid_confirmation_password'}
            labelTextStyle={styles.labelTextStyle}
            containerStyle={styles.passwordInputStyle}
            inputAccessibilityLabel={LoginTestKeys.loginPassTxtInput}
            rightIconAccessibilityLabel={LoginTestKeys.passInputRightIcon}
            selectionColor={theme.colors.textInput.default.selectionColor}
            textColor={theme.colors.textColor}
            helperTextColor={theme.colors.textInput.error.tintColor}
          />

          <VFButton
            title="confirm_new_password_button"
            style={styles.button}
            textStyle={styles.buttonTextStyle}
            disabled={this.getIsFormErrorState() || isSubmitting}
            onPress={this.onNewPasswordConfirm}
            disabledStyle={styles.disabledBUttonStyle(theme)}
            disabledTextStyle={styles.disabledTextStyle(theme)}
            type="primary"
          />
        </View>
      </AuthContainer>
    );
  }
}

ConfirmNewPassword.defaultProps = {
  theme: LightThemeColors,
};

ConfirmNewPassword.propTypes = {
  theme: PropTypes.object,
  navigation: PropTypes.object.isRequired,
  handleValidation: PropTypes.func,
  isValidPhone: null | PropTypes.func,
};

export default withTheme(ConfirmNewPassword);
